import { autorun, makeAutoObservable } from 'mobx';
import { inject, injectable } from 'inversify';
import { UserRole } from '@mobx/interfaces';
import { type RolesService, RolesServiceIdentifier } from '@shared/types/mobx/services/roles';
import { getSelectableRoles } from '@shared/utils/helpers/selectableRoles';

@injectable()
export class SelectRoleViewModel {
  roles: UserRole[] | undefined;

  constructor(@inject(RolesServiceIdentifier) private rolesModule: RolesService) {
    makeAutoObservable(this);

    autorun(() => {
      if (!this.rolesModule.roles.length) return;

      // Правило фильтрации ролей (в т.ч. виртуальная роль «Доверенный») вынесено в
      // getSelectableRoles: тем же списком пользуются гвард «роль выбрана», карточка роли
      // в боковом меню и пункт «Сменить роль» — все считают роли одинаково с этим экраном.
      this.roles = getSelectableRoles(rolesModule.roles);
    });
  }

  selectRole = (role: UserRole) => {
    this.rolesModule.selectRole(role);
  };
}
